// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const personnummer: CountryValidator<"SE", ParsedPersonId> =
  createValidator("se.personnummer", 155);

export default personnummer;
export const compact = personnummer.compact;
export const format = personnummer.format;
export const validate = personnummer.validate;
export const generate = (): string =>
  personnummer.generate?.() ??
  (() => {
    throw new Error(
      "Validator se.personnummer cannot generate values",
    );
  })();
export const parse = personnummer.parse;
